import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-predefined-parameter-list',
  templateUrl: './predefined-parameter-list.component.html',
  styleUrls: ['./predefined-parameter-list.component.css']
})
export class PredefinedParameterListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
